import { createApp } from 'vue'
import JobList from '../components/src/job-list/JobList'

const app = createApp({
  components: {
    JobList,
  }
})

app.mount('#job-list')